import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Box, Button, CircularProgress, Container, Grid, IconButton, Modal, Paper, Stack, Typography } from "@mui/material";
import {
    ArrowForwardIos as ArrowForwardIosIcon,
    Close as CloseIcon,
    Circle as CircleIcon,
    QrCodeScanner as QrCodeScannerIcon,
    Forward as ForwardIcon,
    Image as ImageIcon,
    ReceiptLong as ReceiptLongIcon
} from '@mui/icons-material';
import moment from "moment";
import { getHostLiveEvents, setGetParticipantsListByBookingIdToNull } from "../../../Redux/Slices/Host/LiveEvents/HostLiveEventSlice";
import useCommonStyles from "../../../Styles/CommonStyles";
import { ReactComponent as CalendarIcon } from "../../../assets/EventPreview/CalendarIcon.svg";
import { ReactComponent as ClockIcon } from "../../../assets/EventPreview/ClockIcon.svg";
import QrCodeScanner from "./QrCodeScanner";


export default function LiveEventList(params) {
    const dispatch = useDispatch();
    const commonStyles = useCommonStyles();

    const [openScanPopup, setOpenScanPopup] = useState(false)
    const [openParticiantPopup, setOpenParticiantPopup] = useState(false);


    const LiveEventsData = useSelector(state => state?.HostLiveEventData?.LiveEvents)
    const LiveEventsLoading = useSelector(state => state?.HostLiveEventData?.LiveEventsLoading);

    const getParticipantsListByBookingIdData = useSelector(state => state?.HostLiveEventData?.getParticipantsListByBookingId);

    const RegTypeFields = {
        1: { key: null, label: "Single Rotarian", fields: null },
        2: {
            key: "couplebooking",
            label: 'Couple Registration',
            fields: [
                { label: 'SPOUSE NAME', key: 'spouse_name' },
                { label: 'SPOUSE MOBILE', key: 'spouse_phone' },
                { label: 'SPOUSE FOOD PREFERENCE', key: 'spouse_meal_preference' },
            ]
        },
        3: {
            key: "rajadirajabooking",
            label: 'Maharaja Circle Rajadiraja',
            fields: [
                { label: 'SPOUSE NAME', key: 'spouse_name' },
                { label: 'SPOUSE MOBILE', key: 'spouse_phone' },
                { label: 'SPOUSE FOOD PREFERENCE', key: 'spouse_meal_preference' },
                { label: '1ST ANNET NAME(BELOW 12 YEARS)', key: 'first_annet_name' },
                { label: '2ST ANNET NAME(BELOW 12 YEARS)', key: 'second_annet_name' },
            ]
        },
        4: {
            key: "yuvarajabooking",
            label: 'Maharaja Circle Yuvaraja',
            fields: [
                { label: 'SPOUSE NAME', key: 'spouse_name' },
                { label: 'SPOUSE MOBILE', key: 'spouse_phone' },
                { label: 'SPOUSE FOOD PREFERENCE', key: 'spouse_meal_preference' },
                { label: '1ST ANNET NAME(BELOW 12 YEARS)', key: 'first_annet_name' }
            ]
        },
        5: { key: null, label: "Guest Registration", fields: null },
    }

    useEffect(() => {
        dispatch(getHostLiveEvents({ current_date: moment().format('YYYY-MM-DD') }))
    }, [])

    const findDuration = (startTime, endTime) => {

        if (startTime && endTime) {
            let start = moment(startTime, 'HH:mm');
            let end = moment(endTime, 'HH:mm');



            // Calculate the duration
            let duration = moment.duration(end.diff(start));

            // Get the duration in hours and minutes
            let hours = Math.floor(duration.asHours());
            let minutes = duration.minutes();

            return `${hours}hours ${Number(minutes) > 0 ? `${minutes}minutes` : ''}`
        } else return "-"
    }

    const handleClickScan = (event) => {
        setOpenScanPopup(true)
    }
    const handleCloseScanPopup = () => {
        setOpenScanPopup(false)
    }

    const handleScan = (data) => {
        setOpenScanPopup(false);
        if (data && Array.isArray(data) && data?.length) {
            setOpenParticiantPopup(data[0]);
        }
    }

    const handleCloseParticipantDetails = () => {
        setOpenParticiantPopup(false)
        dispatch(setGetParticipantsListByBookingIdToNull())
    }

    const renderScanner = () => {
        return <Box sx={{ borderRadius: '10px', display: 'flex', flexDirection: 'column', backgroundColor: '#fff', height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 15px' }}>
                <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>Scan QR</Typography>

                <IconButton sx={{}} onClick={() => handleCloseScanPopup()}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box sx={{
                flexGrow: 1, padding: '20px',
                borderRadius: '0px 0px 10px 10px',
                borderTop: '1px solid #A9A9A980',
                backgroundColor: '#F5F6FA'
            }}>
                <Typography sx={{ textAlign: 'center' }}>Camera View</Typography>
                <Box >
                    <QrCodeScanner
                        handleScan={handleScan}
                    />
                </Box>
                <Typography sx={{ textAlign: 'center' }}>Place QR Infront of camera</Typography>
            </Box>
        </Box>
    }



    const renderParticipantDetails = () => {
        let regData = null
        if (RegTypeFields[openParticiantPopup?.registration_type_id]) {

            const key = RegTypeFields[openParticiantPopup?.registration_type_id].key;

            if (key) {
                regData = openParticiantPopup[key]
            }
        }

        return <Box sx={{ borderRadius: '10px', display: 'flex', flexDirection: 'column', backgroundColor: '#fff', height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 15px' }}>
                <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>Participant</Typography>

                <IconButton sx={{}} onClick={() => handleCloseParticipantDetails()}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box sx={{
                flexGrow: 1,
                padding: '20px',
                borderRadius: '0px 0px 10px 10px',
                borderTop: '1px solid #A9A9A980',
                backgroundColor: '#F5F6FA',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflowX: 'auto'
            }}>

                <Stack
                    direction="row"
                    sx={{ minHeight: '100%', height: 'max-content', width: 'fill-available', borderRadius: '20px', backgroundColor: '#fff', boxShadow: "0px 4px 10px 0px #00000026" }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '130px', backgroundColor: '#2D2C3C', borderRadius: '20px 0px 0px 20px', }}>
                        <Typography
                            sx={{
                                fontSize: "18px",
                                writingMode: "vertical-rl",
                                textOrientation: "sideways-right",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: '#FFFFFF',
                                gap: "0.5px",
                                textTransform: "uppercase"
                            }}
                        >
                            {
                                RegTypeFields[openParticiantPopup?.registration_type_id] &&
                                    RegTypeFields[openParticiantPopup?.registration_type_id]?.label ?
                                    RegTypeFields[openParticiantPopup?.registration_type_id]?.label : "-"
                            }
                        </Typography>
                        <Typography sx={{ fontSize: '14px', mt: 1, textAlign: 'center', color: '#FFFFFF' }}>ADMIT</Typography>
                        <Typography sx={{ fontSize: '75px', lineHeight: '1', fontWeight: 700, textAlign: 'center', color: '#FFFFFF' }}>2</Typography>
                    </Box>
                    <Box sx={{ flexGrow: 2, padding: '15px' }}>
                        <Grid container spacing={2} sx={{ height: '100%' }} >
                            <Grid item sm={4} xs={12}>
                                <Box className={commonStyles.customBox}>

                                    <Box margin={1}>
                                        <Typography sx={{ fontSize: '16px', fontWeight: 700 }}>Details</Typography>
                                        <Box mt={1}>
                                            <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>NAME</Typography>
                                            <Typography sx={{ fontSize: '12px' }}>{openParticiantPopup?.full_name ?? "-"}</Typography>
                                        </Box>

                                        <Box mt={1}>
                                            <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>DESIGNATION</Typography>
                                            <Typography sx={{ fontSize: '12px' }}>{openParticiantPopup?.designation ?? "-"}</Typography>
                                        </Box>

                                        <Box mt={1}>
                                            <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>CLUB NAME</Typography>
                                            <Typography sx={{ fontSize: '12px' }}>{openParticiantPopup?.club_name ?? "-"}</Typography>
                                        </Box>

                                        <Box mt={1}>
                                            <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>PHONE NO</Typography>
                                            <Typography sx={{ fontSize: '12px' }}>{openParticiantPopup?.phone ?? "-"}</Typography>
                                        </Box>

                                        <Box mt={1}>
                                            <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>EMAIL</Typography>
                                            <Typography sx={{ fontSize: '12px' }}>{openParticiantPopup?.email ?? "-"}</Typography>
                                        </Box>

                                        <Box mt={1}>
                                            <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>FOOD PREFERENCE</Typography>

                                            <Box>
                                                {Array.isArray(openParticiantPopup?.bookingfood_availability) ?
                                                    openParticiantPopup?.bookingfood_availability?.map((item) => {
                                                        return <Typography sx={{ fontSize: '12px' }}>{item?.food_type?.name}</Typography>
                                                    }) : null}
                                            </Box>

                                        </Box>
                                    </Box>

                                </Box>
                            </Grid>

                            <Grid item sm={4} xs={12}>
                                <Box className={commonStyles.customBox}>

                                    <Box margin={1}>
                                        <Typography sx={{ fontSize: '16px', fontWeight: 700 }}>Registration</Typography>

                                        {RegTypeFields[openParticiantPopup?.registration_type_id] ? <>

                                            <Box mt={1}>
                                                <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>REGISTRATION TYPE</Typography>
                                                <Typography sx={{ fontSize: '12px' }}>
                                                    {
                                                        RegTypeFields[openParticiantPopup?.registration_type_id] &&
                                                            RegTypeFields[openParticiantPopup?.registration_type_id]?.label ?
                                                            RegTypeFields[openParticiantPopup?.registration_type_id]?.label : "-"
                                                    }
                                                </Typography>
                                            </Box>

                                            {RegTypeFields[openParticiantPopup?.registration_type_id]?.fields?.map((item) => {
                                                return <Box mt={1}>
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>{item.label}</Typography>
                                                    <Typography sx={{ fontSize: '12px' }}>{regData && regData[item.key] ? regData[item.key] : "-"}</Typography>
                                                </Box>
                                            })}
                                        </>
                                            : "-"
                                        }
                                    </Box>

                                </Box>
                            </Grid>

                            <Grid item sm={4} xs={12}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    height: '100%'
                                }}>
                                    <Box className={commonStyles.customBox}>
                                        <Box margin={1}>
                                            <Typography sx={{ fontSize: '16px', fontWeight: 700 }}>Annets</Typography>

                                            {openParticiantPopup && Array.isArray(openParticiantPopup?.bookingannets) ?
                                                openParticiantPopup?.bookingannets?.map((item) => {
                                                    return <Box mt={1}>
                                                        <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>{item?.annet_type[0]?.annet_type ?? "-"}</Typography>
                                                        <Typography sx={{ fontSize: '12px' }}>{item?.no_of_annets}</Typography>
                                                    </Box>
                                                }) : "-"
                                            }

                                        </Box>
                                    </Box>

                                    <Box sx={{ border: "1px solid #A9A9A980", borderRadius: '10px', padding: '10px', width: "max-content", alignSelf: "center" }}>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#202224', textAlign: 'center' }}>FOOD TOKENS</Typography>

                                        <Box sx={{ display: 'flex', gap: '15px', mt: 1, justifyContent: 'center' }}>
                                            <Box p={1}>
                                                <Typography sx={{ fontSize: '14px', color: '#009C2C' }}>VEG</Typography>
                                                <Typography sx={{ fontSize: '35px', color: '#009C2C', lineHeight: '1', fontWeight: 700, textAlign: 'center', }} >2</Typography>
                                            </Box>

                                            <Box p={1}>
                                                <Typography sx={{ fontSize: '14px', color: '#EF3826' }}>NON VEG</Typography>
                                                <Typography sx={{ fontSize: '35px', color: "#EF3826", lineHeight: '1', fontWeight: 700, textAlign: 'center', }} >2</Typography>
                                            </Box>

                                            <Box p={1}>
                                                <Typography sx={{ fontSize: '14px', color: '#242565' }}>ANNETS</Typography>
                                                <Typography sx={{ fontSize: '35px', color: '#242565', lineHeight: '1', fontWeight: 700, textAlign: 'center', }} >2</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                </Stack>
            </Box >

            <Box sx={{ padding: '15px', boxShadow: '0px -4px 10px 0px #1D1D1D26' }}>
                <Box sx={{ display: 'flex', height: '100%', width: '100%', justifyContent: 'space-between', gap: '10px' }}>
                    <Button sx={{ width: { xs: '100%', sm: 'auto', md: 'auto' } }} startIcon={<QrCodeScannerIcon />} variant="contained">Scan again</Button>

                    <Box sx={{ display: 'flex', gap: '10px' }}>
                        <Button variant="outlined" sx={{ width: { xs: '100%', sm: 'auto', md: 'auto' } }} startIcon={<ImageIcon />}>Save as Image</Button>
                        <Button variant="contained" sx={{ width: { xs: '100%', sm: 'auto', md: 'auto' } }} startIcon={<ReceiptLongIcon />}>Food Tokens</Button>
                        <Button sx={{
                            color: '#009C2C',
                            border: "1px solid #009C2C",
                            "&:hover": {
                                border: '1px solid #009C2C'
                            },
                            width: { xs: '100%', sm: 'auto', md: 'auto' }
                        }} endIcon={<ForwardIcon />} variant="outlined">Entered</Button>
                    </Box>
                </Box>
            </Box>


        </Box >
    }

    console.log(openParticiantPopup, 'openParticiantPopup');

    return <>
        <Modal
            open={Boolean(openScanPopup)}
            sx={{ backdropFilter: "blur(2px)" }}
        >
            <Container style={{ padding: "5px", border: 'none', width: 400, height: '500px', overflow: 'auto' }}>
                {renderScanner()}
            </Container>
        </Modal>

        <Modal
            open={Boolean(openParticiantPopup)}
            sx={{ backdropFilter: "blur(2px)" }}
        >
            <Container sx={{ padding: "5px", outline: 'none', height: "100vh", width: { sm: 1000, md: 1000, xl: 1200, xs: "100%" }, overflow: 'hidden' }}>
                {renderParticipantDetails()}
            </Container>
        </Modal>

        <Stack
            gap={"10px"}
        >
            {LiveEventsLoading ?
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress sx={{}} />
                </Box> : Array.isArray(LiveEventsData?.data?.events) &&
                    LiveEventsData?.data?.events?.length ?
                    LiveEventsData?.data?.events?.map((item) => {

                        return <Grid container component={Paper} elevation={0}>
                            <Grid sm={8} xs={12}>
                                <Box sx={{ padding: '15px' }}>
                                    <Typography sx={{ fontWeight: '600', fontSize: '14px', color: '#2D2C3C' }}>{item?.event[0]?.title}</Typography>

                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Typography
                                            sx={{ fontWeight: '600', fontSize: '14px', color: '#2D2C3C' }}
                                        >
                                            {item?.event[0]?.rotarian?.rotarian_district ?? "-"}
                                        </Typography> &nbsp;
                                        <CircleIcon sx={{ fontSize: '10px' }} />
                                        &nbsp;
                                        <Typography sx={{ fontWeight: '600', fontSize: '14px', color: '#2D2C3C' }}>
                                            {item?.event[0]?.rotarian.rotarian_id}
                                        </Typography>
                                    </Box>

                                    <Box mt={1}>
                                        <Typography className={commonStyles.commonFormTitle}>Date & Time</Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}> <CalendarIcon style={{ padding: "5px 0px" }} /> &nbsp;
                                            <Typography className={commonStyles.InputLabel}>{item?.event[0]?.duration_start_date ? moment(item?.event[0]?.duration_start_date).format('dddd, D MMMM YYYY') : null}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <ClockIcon style={{ padding: "5px 0px" }} /> &nbsp;
                                            <Typography className={commonStyles.InputLabel}>{Boolean(item?.event[0]?.duration_from_time) && moment(item?.event[0]?.duration_from_time, 'HH:mm').format('h:mm A')} -  {Boolean(item?.event[0]?.duration_to_time) && moment(item?.event[0]?.duration_to_time, 'HH:mm').format('h:mm A')}</Typography>&nbsp;
                                            <Typography className={commonStyles.InputLabel}>{findDuration(item?.event[0]?.duration_from_time, item?.event[0]?.duration_to_time)}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid sm={4} xs={12}>
                                <Box sx={{ padding: '15px', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'space-between' }}>
                                    <Box sx={{ backgroundColor: '#FCD7D4', padding: '5px', borderRadius: '8px', color: '#EF3826' }}>
                                        <Typography sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontWeight: '600', fontSize: '12px' }}><CircleIcon sx={{ fontSize: '8px' }} /> Live</Typography>
                                    </Box>

                                    <Button variant="contained" onClick={() => handleClickScan(item?.event[0])} startIcon={<QrCodeScannerIcon />}>Scan</Button>
                                </Box>
                            </Grid>
                        </Grid>

                    }) : <Box sx={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                    >
                        <Typography>No data found</Typography>
                    </Box>
            }


        </Stack >
    </>
}